// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"322":"9e62aa03","625":"a5948157"}[chunkId] + ".chunk.js";
};